import { analyticsIds } from '../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../constants/cypressIds';
import { JobProfilePage } from '../../../../../constants/duskIds';

export const multiSelectInsuredsOptions = {
  search: { key: 'search', label: 'Search Insureds', dataAnalyticsId: analyticsIds.projectDetailsPage.searchInsuredsTab, dusk: JobProfilePage.selectInsuredsOptionButton, cypressId: '' },
  addNew: { key: 'addNew', label: 'Add Insured to List', dataAnalyticsId: analyticsIds.projectDetailsPage.addInsuredToListTab, dusk: JobProfilePage.addInsuredToListOptionButton, cypressId: CypressIds.createRecordTrayCreateNewInsuredTab }
};
